export const styles = {
  buttons_wrapper: {
    zIndex: 2,
    display: "flex",
    gap: '5px'
  },
  button: {
    // height: "38px",
    // marginRight: "5px"
  }
};
